import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
// ✅ THE FIX IS HERE: The path now correctly goes up two directories
import { useAccessibility } from '../../context/AccessibilityContext'; 
import { playSound } from '../../utils/sound';

export default function SoundManager() {
  const location = useLocation();
  const { soundEnabled } = useAccessibility();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    // Prevent sound on the very first page load, but allow it on refreshes.
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    // Play a sound on every subsequent navigation
    playSound('navigate.mp3', soundEnabled);

  }, [location.pathname, soundEnabled]); // Effect runs when the page path changes

  return null; // This component renders nothing
}